export const ManPower = () => import('./ManPower.vue');
